import { useEffect, useRef, useState } from "react";
import { useFetchSearchBar } from "hooks";
import styles from "./SearchBar.module.scss";
import { NavLink } from "react-router-dom";

function SearchBar() {
  const [search, setSearch] = useState("");
  const [pokemons, isLoading] = useFetchSearchBar(search);
  const [isOpen, setIsOpen] = useState(false);

  const dropdownRef = useRef<HTMLDivElement>(null);
  let timerID: any = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
    e.target.value === "" ? setIsOpen(false) : setIsOpen(true);
  };

  const handleBlur = () => {
    timerID.current = setTimeout(() => setIsOpen(false), 200);
  };

  const handleFocus = () => {
    setIsOpen(true);
    search === "" && setIsOpen(false);
  };

  const handleClickItem = () => {
    clearTimeout(timerID.current);
    setIsOpen(false);
  };

  return (
    <div className={`${styles.searchBar}`}>
      <input
        type="text"
        placeholder="Search for a Pokemon"
        value={search}
        onChange={handleSearchChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
      />

      {isOpen && (
        <div className={styles.dropdown} ref={dropdownRef}>
          {isLoading ? (
            <div className={styles.loading}>Loading...</div>
          ) : (
            pokemons.map((pokemon, index) =>
              pokemon ? (
                <NavLink
                  to={`/pokemon/${pokemon.id_name}`}
                  onClick={handleClickItem}
                >
                  <div key={index} className={styles.dropdownItem}>
                    <img
                      src={pokemon.image}
                      alt={pokemon.name}
                      className={styles.pokemonImage}
                    />
                    <div className={styles.pokemonInfo}>
                      <strong className={styles.pokemonName}>
                        {pokemon.name}
                      </strong>
                      <span className={styles.pokemonNumber}>
                        {"#" +
                          String(pokemon.pokemon_species.entry_nb).padStart(
                            4,
                            "0"
                          )}
                      </span>
                    </div>
                  </div>
                </NavLink>
              ) : (
                <div className="p-10">No Pokemon was found...</div>
              )
            )
          )}
        </div>
      )}
    </div>
  );
}
export default SearchBar;
